<h1 mat-dialog-title class="textFont">{{getTitle()}}</h1>
<div mat-dialog-content>
    <p class="textFont">{{getContent()}}</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()" class="btn-center">{{getOkButtonLabel()}}</button>
</div>